import theme from "@shared/utils/themeColors";
import React, { useEffect, useState } from "react";
import { useTutorContext } from "../context/TutorContext";
import TutorChatWindow from "./TutorChatWindow";

/**
 * Floating Ask a Tutor chat bubble
 * Positioned on the left side of the screen and higher than the support bubble
 */
const TutorChatBubble: React.FC = () => {
  const {
    isChatOpen,
    toggleChat,
    selectedConversationId,
    setSelectedConversationId,
    createConversation,
  } = useTutorContext();

  const [isAnimating, setIsAnimating] = useState(false);

  // Function to start the bounce animation
  const startAnimation = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsAnimating(false);
    }, 4000);
  };

  // Show animation periodically to draw attention
  useEffect(() => {
    if (isChatOpen) return;

    // Show animation when component loads
    startAnimation();

    // Set interval to show animation periodically
    const intervalId = setInterval(() => {
      if (!isChatOpen) {
        startAnimation();
      }
    }, 3 * 60 * 1000); // Every 3 minutes

    return () => clearInterval(intervalId);
  }, [isChatOpen]);

  // Handle opening the chat
  const handleOpenChat = async () => {
    if (!isChatOpen) {
      toggleChat();
    } else {
      toggleChat();
    }
  };

  return (
    <>
      {/* Chat Button with Tooltip */}
      <div className="fixed bottom-8 left-6 z-40 group absolute w-[256px]">
        <button
          onClick={handleOpenChat}
          className={`w-14 h-14 rounded-full ${
            theme.bg.brand
          } text-white flex items-center justify-center shadow-lg hover:brightness-105 transition-all ${
            isAnimating ? "animate-bounce-gentle" : ""
          }`}
          aria-label="Ask a Tutor Chat"
        >
          <img
            className="object-center"
            src="/assets/images/welcome-back-graphic.svg"
          />
        </button>

        {/* Simple tooltip that appears on hover */}
        <div
          className={`absolute left-14 ml-2 bottom-3  bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-100 px-3 py-1 rounded shadow-md border border-gray-200 dark:border-gray-700/60 opacity-0 group-hover:opacity-100 transition-opacity  ${
            isAnimating && !isChatOpen
              ? "animate-bounce-gentle opacity-100"
              : ""
          }`}
        >
          Ask a Tutor
        </div>
      </div>

      <div
        className={`fixed bottom-28 left-6 z-50  max-w-[90%] max-h-[80%]  transition-opacity duration-300 ${
          isChatOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <TutorChatWindow />
      </div>
    </>
  );
};

export default TutorChatBubble;
